<script setup>
const { t } = useI18n({})
const route = useRoute()

const { data: faqData } = await useApi('/api/faqs/categories')
const { data: faqQuestionsData } = await useApi('/api/faqs/questions')

const faq = computed(() => faqData.value)
const faqQuestions = computed(() => faqQuestionsData.value)

const search = ref('')

const faqType = route.params.filters[0]
const faqCategory = route.params.filters[1]

const selectedFaqType = computed(() => faq.value?.find(x => x.slug === faqType))
const selectedFaqCategory = computed(() => selectedFaqType.value?.children.find(x => x.slug === faqCategory))
const selectedFaqQuestions = computed(() => selectedFaqCategory.value ? faqQuestions.value.filter(x => x.faq_category_id === selectedFaqCategory.value?.id) : faqQuestions.value)

const searchedQuestions = computed(() => search.value
  ? faqQuestions.value.filter(question => question.question.toLowerCase().includes(search.value.toLowerCase()) || question.answer.toLowerCase().includes(search.value.toLowerCase()))
  : faqQuestions.value,
)

const shownQuestions = computed(() => {
  if (search.value !== '')
    return searchedQuestions.value
  return selectedFaqQuestions.value
})

provide('faq', faq)

useHead({
  title: t('account.faq'),
})
</script>

<template>
  <div class="my-12 flex w-full flex-col gap-8 md:flex-row mx-auto container px-2 items-start">
    <div class="flex w-full md:w-64 border rounded-lg p-4">
      <FaqSidebar :faq-category="faqCategory" :faq-type="faqType" />
    </div>

    <div class="w-full">
      <div class="relative mb-4 w-full">
        <input
          v-model="search" class="bg-sand w-full rounded-xl bg-opacity-40 p-4"
          :placeholder="t('faq.search_placeholder')" @focus="hidden = false"
        >
        <div class="absolute flex flex-center px-4 pointer-events-none right-0 top-0 bottom-0">
          <img class="" src="~/assets/images/icons/search.svg" alt="Search">
        </div>
      </div>
      <template v-for="question in shownQuestions" :key="question.id">
        <FaqQuestion
          :question="question"
        />
        <div class="h-px bg-primary/20 last:hidden" />
      </template>
    </div>
  </div>
</template>
